var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7617 4.13672L19.5586 8.93359C19.8398 9.21484 20 9.60156 20 10C20 10.3984 19.8398 10.7852 19.5586 11.0664L14.7617 15.8633C14.5117 16.1133 14.1758 16.25 13.8242 16.25C13.0937 16.25 12.5 15.6563 12.5 14.9258V12.5H7.5C6.80859 12.5 6.25 11.9414 6.25 11.25V8.75C6.25 8.05859 6.80859 7.5 7.5 7.5H12.5V5.07422C12.5 4.34375 13.0937 3.75 13.8242 3.75C14.1758 3.75 14.5117 3.89063 14.7617 4.13672ZM6.25 3.75H3.75C3.05859 3.75 2.5 4.30859 2.5 5V15C2.5 15.6914 3.05859 16.25 3.75 16.25H6.25C6.94141 16.25 7.5 16.8086 7.5 17.5C7.5 18.1914 6.94141 18.75 6.25 18.75H3.75C1.67969 18.75 0 17.0703 0 15V5C0 2.92969 1.67969 1.25 3.75 1.25H6.25C6.94141 1.25 7.5 1.80859 7.5 2.5C7.5 3.19141 6.94141 3.75 6.25 3.75Z",
    fill: "#43BBC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.0b8df9d0ae9b674e8fefd95dbb2b7631.svg";
export { ForwardRef as ReactComponent };